import axios from 'axios';

const desyncCalendar = async () => {
  const config = {
    url: `/almanac/desync_calendar`,
    method: 'get' as const,
  };

  const { data } = await axios.request(config);
  return data;
};

export default desyncCalendar;
